// extracted by mini-css-extract-plugin
export default {"overlay":"pz-z","bodyOpen":"qz-z","content":"rz-z","header":"sz-z","close":"tz-z","closeNoHeading":"uz-z"};